export const checkIns = [
    {
      id: 'ci-001',
      passengerName: 'John Smith',
      flightNumber: 'BA456',
      origin: 'LHR',
      destination: 'JFK',
      departureDate: '2023-08-15T08:30:00',
      checkInTime: '2023-08-14T20:15:32',
      status: 'completed',
      boardingPass: true,
      seatNumber: '12A',
      gate: 'B22',
      boardingTime: '2023-08-15T07:30:00',
      baggage: [
        { id: 'bag-001', weight: '23kg', tag: 'BA456-001' }
      ]
    },
    {
      id: 'ci-002',
      passengerName: 'Emily Johnson',
      flightNumber: 'LH218',
      origin: 'FRA',
      destination: 'LAX',
      departureDate: '2023-08-16T14:45:00',
      checkInTime: '2023-08-15T14:22:10',
      status: 'completed',
      boardingPass: true,
      seatNumber: '18F',
      gate: 'A10',
      boardingTime: '2023-08-16T13:45:00',
      baggage: [
        { id: 'bag-002', weight: '20kg', tag: 'LH218-002' },
        { id: 'bag-003', weight: '15kg', tag: 'LH218-003' }
      ]
    },
    {
      id: 'ci-003',
      passengerName: 'Michael Brown',
      flightNumber: 'EK302',
      origin: 'DXB',
      destination: 'SYD',
      departureDate: '2023-08-17T23:15:00',
      checkInTime: '2023-08-16T23:05:45',
      status: 'in-progress',
      boardingPass: false,
      seatNumber: null,
      gate: null,
      boardingTime: '2023-08-17T22:15:00',
      baggage: []
    },
    {
      id: 'ci-004',
      passengerName: 'Sarah Wilson',
      flightNumber: 'QF128',
      origin: 'SIN',
      destination: 'MEL',
      departureDate: '2023-08-15T19:20:00',
      checkInTime: '2023-08-14T19:10:22',
      status: 'failed',
      boardingPass: false,
      seatNumber: null,
      gate: null,
      boardingTime: null,
      baggage: [],
      error: 'Passport information mismatch'
    },
    {
      id: 'ci-005',
      passengerName: 'David Lee',
      flightNumber: 'AF123',
      origin: 'CDG',
      destination: 'MAD',
      departureDate: '2023-08-18T10:05:00',
      checkInTime: '2023-08-17T10:01:15',
      status: 'completed',
      boardingPass: true,
      seatNumber: '8C',
      gate: 'D15',
      boardingTime: '2023-08-18T09:05:00',
      baggage: [
        { id: 'bag-004', weight: '18kg', tag: 'AF123-004' }
      ]
    },
    {
      id: 'ci-006',
      passengerName: 'Jessica Martinez',
      flightNumber: 'UA789',
      origin: 'ORD',
      destination: 'SFO',
      departureDate: '2023-08-16T07:30:00',
      checkInTime: '2023-08-15T07:25:50',
      status: 'in-progress',
      boardingPass: false,
      seatNumber: null,
      gate: null,
      boardingTime: '2023-08-16T06:30:00',
      baggage: []
    },
    {
      id: 'ci-007',
      passengerName: 'Robert Taylor',
      flightNumber: 'SQ321',
      origin: 'SIN',
      destination: 'HKG',
      departureDate: '2023-08-19T16:40:00',
      checkInTime: '2023-08-18T16:35:12',
      status: 'completed',
      boardingPass: true,
      seatNumber: '24D',
      gate: 'C8',
      boardingTime: '2023-08-19T15:40:00',
      baggage: [
        { id: 'bag-005', weight: '22kg', tag: 'SQ321-005' }
      ]
    },
    {
      id: 'ci-008',
      passengerName: 'Amanda Clark',
      flightNumber: 'DL456',
      origin: 'ATL',
      destination: 'LHR',
      departureDate: '2023-08-20T22:10:00',
      checkInTime: '2023-08-19T22:05:33',
      status: 'failed',
      boardingPass: false,
      seatNumber: null,
      gate: null,
      boardingTime: null,
      baggage: [],
      error: 'Visa verification failed'
    },
    {
      id: 'ci-008a',
      passengerName: 'Mark Wilson',
      flightNumber: 'BA789',
      origin: 'LHR',
      destination: 'JFK',
      departureDate: '2023-08-21T15:30:00',
      checkInTime: null,
      status: 'scheduled',
      boardingPass: false,
      seatNumber: null,
      gate: null,
      boardingTime: null,
      baggage: []
    },
    {
      id: 'ci-008b',
      passengerName: 'Lisa Anderson',
      flightNumber: 'LH567',
      origin: 'FRA',
      destination: 'LAX',
      departureDate: '2023-08-22T11:45:00',
      checkInTime: '2023-08-21T11:40:15',
      status: 'manual_intervention_required',
      boardingPass: false,
      seatNumber: null,
      gate: null,
      boardingTime: null,
      baggage: [],
      error: 'Document verification required'
    },
    {
      id: 'ci-009',
      status: 'completed',
      checkInTime: '2023-09-01T14:22:10',
      boardingPass: true,
      tripType: 'International',
      // Multiple flights for layovers
      flights: [
        {
          flightNumber: 'EK203',
          origin: 'JFK',
          destination: 'DXB',
          departure: '2023-09-03T22:30:00',
          arrival: '2023-09-04T19:15:00',
          gate: 'A12',
          boardingTime: '2023-09-03T21:30:00',
          terminal: 'Terminal 4'
        },
        {
          flightNumber: 'EK504',
          origin: 'DXB',
          destination: 'BOM',
          departure: '2023-09-05T03:45:00',
          arrival: '2023-09-05T08:30:00',
          gate: 'C22',
          boardingTime: '2023-09-05T03:00:00',
          terminal: 'Terminal 3'
        }
      ],
      // Multiple passengers
      passengers: [
        {
          firstName: 'Raj',
          lastName: 'Patel',
          seatNumber: '34A',
          mealPreference: 'Vegetarian',
          passport: {
            number: 'P1234567',
            nationality: 'Indian',
            expiry: '2028-05-15T00:00:00'
          }
        },
        {
          firstName: 'Priya',
          lastName: 'Patel',
          seatNumber: '34B',
          mealPreference: 'Vegetarian',
          passport: {
            number: 'P7654321',
            nationality: 'Indian',
            expiry: '2027-11-20T00:00:00'
          }
        },
        {
          firstName: 'Arjun',
          lastName: 'Patel',
          seatNumber: '34C',
          mealPreference: 'Child Meal',
          passport: {
            number: 'P9876543',
            nationality: 'Indian',
            expiry: '2026-08-10T00:00:00'
          }
        }
      ],
      baggage: [
        { id: 'bag-010', weight: '23kg', tag: 'EK203-010' },
        { id: 'bag-011', weight: '23kg', tag: 'EK203-011' },
        { id: 'bag-012', weight: '15kg', tag: 'EK203-012' },
        { id: 'bag-013', weight: '10kg', tag: 'EK203-013' }
      ]
    },
    {
      id: 'ci-010',
      status: 'completed',
      checkInTime: '2023-10-05T09:15:45',
      boardingPass: true,
      tripType: 'International',
      // Multiple flights for layovers
      flights: [
        {
          flightNumber: 'UA857',
          origin: 'SFO',
          destination: 'FRA',
          departure: '2023-10-07T18:45:00',
          arrival: '2023-10-08T14:30:00',
          gate: 'G91',
          boardingTime: '2023-10-07T17:45:00',
          terminal: 'International Terminal'
        },
        {
          flightNumber: 'LH1234',
          origin: 'FRA',
          destination: 'FCO',
          departure: '2023-10-08T16:20:00',
          arrival: '2023-10-08T18:10:00',
          gate: 'A15',
          boardingTime: '2023-10-08T15:50:00',
          terminal: 'Terminal 1'
        }
      ],
      // Multiple passengers
      passengers: [
        {
          firstName: 'Michael',
          lastName: 'Johnson',
          seatNumber: '7A',
          mealPreference: 'Regular',
          passport: {
            number: 'US789456',
            nationality: 'American',
            expiry: '2029-03-22T00:00:00'
          }
        },
        {
          firstName: 'Jennifer',
          lastName: 'Johnson',
          seatNumber: '7B',
          mealPreference: 'Gluten Free',
          passport: {
            number: 'US789457',
            nationality: 'American',
            expiry: '2029-03-22T00:00:00'
          }
        }
      ],
      baggage: [
        { id: 'bag-014', weight: '22kg', tag: 'UA857-014' },
        { id: 'bag-015', weight: '22kg', tag: 'UA857-015' },
        { id: 'bag-016', weight: '18kg', tag: 'UA857-016' }
      ]
    },
    {
      id: 'ci-011',
      status: 'in-progress',
      checkInTime: '2023-11-10T11:30:20',
      boardingPass: false,
      tripType: 'Domestic',
      // Multiple flights for domestic connection
      flights: [
        {
          flightNumber: 'DL1492',
          origin: 'LAX',
          destination: 'ATL',
          departure: '2023-11-12T07:15:00',
          arrival: '2023-11-12T14:45:00',
          gate: 'T5',
          boardingTime: '2023-11-12T06:35:00',
          terminal: 'Terminal 5'
        },
        {
          flightNumber: 'DL822',
          origin: 'ATL',
          destination: 'MIA',
          departure: '2023-11-12T16:30:00',
          arrival: '2023-11-12T18:15:00',
          gate: 'A12',
          boardingTime: '2023-11-12T15:50:00',
          terminal: 'Terminal A'
        }
      ],
      // Multiple passengers
      passengers: [
        {
          firstName: 'Carlos',
          lastName: 'Rodriguez',
          seatNumber: '15F',
          mealPreference: 'Regular',
          passport: {
            number: 'N/A',
            nationality: 'American',
            expiry: ''
          }
        },
        {
          firstName: 'Maria',
          lastName: 'Rodriguez',
          seatNumber: '15E',
          mealPreference: 'Diabetic',
          passport: {
            number: 'N/A',
            nationality: 'American',
            expiry: ''
          }
        },
        {
          firstName: 'Sofia',
          lastName: 'Rodriguez',
          seatNumber: '15D',
          mealPreference: 'Child Meal',
          passport: {
            number: 'N/A',
            nationality: 'American',
            expiry: ''
          }
        },
        {
          firstName: 'Luis',
          lastName: 'Rodriguez',
          seatNumber: '15C',
          mealPreference: 'Regular',
          passport: {
            number: 'N/A',
            nationality: 'American',
            expiry: ''
          }
        }
      ],
      baggage: [
        { id: 'bag-017', weight: '23kg', tag: 'DL1492-017' },
        { id: 'bag-018', weight: '23kg', tag: 'DL1492-018' },
        { id: 'bag-019', weight: '23kg', tag: 'DL1492-019' },
        { id: 'bag-020', weight: '15kg', tag: 'DL1492-020' },
        { id: 'bag-021', weight: '10kg', tag: 'DL1492-021' }
      ]
    }
  ];
  
  export default checkIns;